// Helper for the knowledge-recency timeline. Pulls a parseable epoch from
// either effective_date (preferred, per spec §6D) or created_at as fallback.

export function toEpoch(row) {
  const raw = row?.effective_date || row?.created_at;
  if (!raw) return null;
  const t = new Date(raw).getTime();
  return Number.isFinite(t) ? t : null;
}

/**
 * Split the 6D timeline into the facts AI knows and the facts it doesn't.
 *
 * `fn_get_aim_knowledge_recency_timeline` returns one row per current
 * ground-truth fact, carrying `ai_knows`, `fact_key`, `fact_value`,
 * `fact_category` and `effective_date`.
 *
 * Only rows that name a fact are classified. Anything else — a per-date
 * timeline grain, junk entries — carries no verdict about any fact, so it is
 * dropped rather than swept into "AI doesn't know", which would assert AI is
 * unaware of facts the payload says nothing about.
 *
 * @param {Array|null|undefined} timeline the timeline payload
 * @returns {{mode: 'per-fact'|'empty', known: Array, unknown: Array}}
 */
export function knowledgeRecencyView(timeline) {
  const facts = (Array.isArray(timeline) ? timeline : [])
    .filter((r) => r && typeof r === 'object' && r.fact_key);
  if (facts.length === 0) return { mode: 'empty', known: [], unknown: [] };

  return {
    mode: 'per-fact',
    known: facts.filter((r) => r.ai_knows),
    unknown: facts.filter((r) => !r.ai_knows),
  };
}
